import DataImport from "../../services/DataImport";
const state = {};
const getters = {};
const mutations = {};

const actions = {
  importData({ commit }, payload) {
    console.log(payload);
    console.log(commit);
    DataImport.sendData(payload).then((response) => {
      console.log(response);
    });
  },

  importInnoDotData({ commit }, payload) {
    console.log(commit);
    DataImport.sendInnoDotData(payload).then((response) => {
      console.log(response);
    });
  },

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
